module.exports = __webpack_public_path__ + "img/plb6.ef23e771.png";